import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "headNav" }
const _hoisted_2 = { class: "tab-menu" }

import { reactive, ref, computed, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

let router = useRouter();
onMounted (() => {
   
})

watch(
    ()=>router.currentRoute.value,
    (newValue:any)=>{
        if(newValue.path=='/ruike'){
            router.go(-1)
        }
    },
    {immediate:true}
)

const { t, locale } = useI18n()
const langList = reactive([{ name: '中文', enName: 'zh', }, { name: 'En', enName: 'en', }]);
let monmentLang = ref(sessionStorage.getItem('language') || navigator.language.split('-')[0] || 'en');
let menuList = computed(() => {
    return reactive([
        { name: t('navMenu.home'), path: '/', routeName: 'home' },
        { name: t('navMenu.aboutUs'), path: '/about', routeName: 'companyInfor' },
        { 
            name: t('navMenu.assessServe'),
            path: '/serve',
            routeName: 'riskCompliance',
        },
        { 
            name: t('navMenu.teleProduct'), 
            path: '/product',
            routeName: 'regulatoryTechProduct' 
        },
        { name: t('navMenu.ruike'), 
          path: '/ruike'
        },
        { name: t('navMenu.news_d'), 
          path: '/news'
        },
        { name: t('navMenu.talentRecruitment'), path: '/recruit', routeName: 'talentRecruitment' },
    ])
}) 
const changeLang = (val: { enName: string; }) => {
    monmentLang.value = val.enName;
    locale.value = val.enName;
    sessionStorage.setItem('language', val.enName)
}
const ruike=(val: { enName: object; })=>{
    if(val.path=='/ruike'){
        window.open('http://academy.reghubchina.com')
    }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuList), (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (item.path)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: index,
                to: { path: item.path },
                onClick: ($event: any) => (ruike(item))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("li", {
                    class: _normalizeClass(_ctx.$route.name === item.routeName || _ctx.$route.matched[1].name === item.routeName ? 'active' : '')
                  }, _toDisplayString(item.name), 3)
                ]),
                _: 2
              }, 1032, ["to", "onClick"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 256))
    ])
  ]))
}
}

})